import {Component, Input, OnInit} from '@angular/core';
import {SubmitConfirmationCodeFormComponent} from '../../submit-confirmation-code-form/submit-confirmation-code-form.component';
import {trigger} from '@angular/animations';
import {smoothEnterLeaveAnimation} from '../../../../../shared/animations/custom-animations';
import {ForgotPasswordService} from '../../../../services/forgot-password.service';
import * as OtpOptions from '../../../../../shared/constants/otp-options.const';
import {DomainNameParserService} from 'src/main/resources/static/angular2/app/shared/services/domain-name-parser.service';
import {PHONE_NUMBER_LIST} from '../../../../../shared/constants/phone-numbers.const';

@Component({
  selector: 'app-verify-confirmation-code-by-email',
  templateUrl: './verify-confirmation-code-by-email.component.html',
  styleUrls: [
    './verify-confirmation-code-by-email.component.css',
    '../../../../../../assets/css/floating-labels.css'
  ],
  animations: [
    trigger('showVerificationCodeResentMessage', smoothEnterLeaveAnimation('100ms', '100ms')),
    trigger('submittedConfirmationCodeAlert', smoothEnterLeaveAnimation('100ms 300ms', '100ms'))
  ]
})
export class VerifyConfirmationCodeByEmailComponent implements OnInit {

  resendVerificationEmailButtonClicked = false;
  customerServicePhone: string;

  @Input()
  public username: string;

  @Input()
  public emailAddress: string;

  constructor(private forgotPasswordService: ForgotPasswordService,
              private domainNameParserService: DomainNameParserService) {
    this.customerServicePhone = PHONE_NUMBER_LIST[this.domainNameParserService.getState()];
  }

  ngOnInit(): void {
  }

  resendVerificationEmail(confirmationCodeFormComponent: SubmitConfirmationCodeFormComponent): void {
    console.log('Resending verification email with confirmation code...');
    this.resendVerificationEmailButtonClicked = true;

    this.forgotPasswordService.requestOneTimePassword(this.username, OtpOptions.EMAIL_OTP_OPTION, this.emailAddress).subscribe(_ => {
      console.log('Requesting one time password by email again...');
      confirmationCodeFormComponent.setSubmitConfirmationCodeErrorType(null);
    });
  }
}
